/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Remove_User_Transfer_HintInputs */



/**
* | output |
* | --- |
* | "If they are the only administrator of a shared space, transfer ownership first — you can do that from their detail page." |
*
* @param {Members_Remove_User_Transfer_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_remove_user_transfer_hint = /** @type {((inputs?: Members_Remove_User_Transfer_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Remove_User_Transfer_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn das Mitglied der einzige Administrator eines geteilten Space ist, übertragen Sie zuerst den Besitz — das geht auf der Detailseite des Mitglieds.")
	return /** @type {LocalizedString} */ ("If they are the only administrator of a shared space, transfer ownership first — you can do that from their detail page.")
});